<template lang="pug">
b-container.dsg-page(fluid)

    //---- Add New Appointment modal ----//
    b-modal(id="new-appointment" title="Add New Appointment" modal-class="dsg-modal" body-class="position-static" size="lg" no-close-on-backdrop scrollable)
        b-overlay(no-wrap :show="isSubmitAddNewAppointment")
            template(#overlay)
        template
            .dsg-form-section
                .dsg-form-section-title
                    Icon.mr-2(icon="mdi:account-outline")
                    | Client &amp; caregiver
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Client Name
                            span.dsg-req  *
                        b-form-input(id="input-1" v-model="inputNewAppointment.clientName" type="text" placeholder="Enter client name")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Caregiver Name
                            span.dsg-req  *
                        b-form-input(id="input-3" v-model="inputNewAppointment.caregiverName" type="text" placeholder="Enter caregiver name")
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Caregiver Email
                            span.dsg-req  *
                        b-form-input(id="input-4" v-model="inputNewAppointment.email" type="email" placeholder="Enter caregiver email")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Phone Number
                        b-form-input(id="input-5" v-model="inputNewAppointment.phoneNumber" type="tel" placeholder="Enter phone number")

            .dsg-form-section
                .dsg-form-section-title
                    Icon.mr-2(icon="mdi:calendar-clock")
                    | Schedule
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment Start Date
                            span.dsg-req  *
                        b-form-datepicker(id="input-startdate" :min="todayDate" v-model="inputNewAppointment.appointmentStartDate")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment Start Time
                            span.dsg-req  *
                        p.dsg-inline-warn(v-if="notValidTime") Minimum 30 minutes from now.
                        b-time.w-100(id="input-starttime" locale="en" :min="minTime" v-model="inputNewAppointment.appointmentStartTime")
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment Hours
                        b-form-select(id="input-houroptions" v-model="inputNewAppointment.appointmentHour" :options="listOptionAppointmentHour")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment End Date and Time
                        b-form-input(type="text" :value="appointmentEndDateIsoString" disabled)
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Type of Client
                        b-form-select(v-model="inputNewAppointment.typeClient" :options="listOptionTypeClient")

        template(#modal-footer)
            .d-flex.align-items-center.justify-content-between.w-100
                small.text-muted(v-if="disableSubmit")
                    | Fill in all fields marked with
                    span.dsg-req  *
                span(v-else)
                .d-flex(style="gap: 0.5rem;")
                    b-button(variant="light" @click="$bvModal.hide('new-appointment')") Cancel
                    b-button.btn-dsg(@click="onSubmit" :disabled="disableSubmit")
                        Icon.mr-1(icon="mdi:plus")
                        | Add Appointment

    //---- More info modal (legacy) ----//
    b-modal(:id="nameModal.modalClientId" title="More Info" modal-class="dsg-modal")
        template
        b-col(v-for="client in nameModal.data" :key="client.id" style="text-align: center;")
            b-row.p-2(style="display: flex; align-items: center; justify-content: center; background-color: #50276D; color: white; font-weight: 400; font-size: medium;")
                b-col Phone Number
                b-col Email
            b-row.p-2(style="border: 1px solid black; display: flex; align-items: center;")
                b-col {{ client.clientContact }}
                b-col {{ client.clientEmail }}
        template(#modal-footer)
            b-button(variant="light" @click="hideNameModal") Close

    //---- Delete confirmation modal ----//
    b-modal(:id="modalDeleteAppointment.modalId" title="Delete Appointment" modal-class="dsg-modal" body-class="position-static" no-close-on-backdrop)
        b-overlay(no-wrap :show="modalDeleteAppointment.isDeleteAppointmentItem")
            template(#overlay)
        template
            .text-center.py-2
                Icon(icon="mdi:alert-circle-outline" width="52" style="color: #dc3545;")
                p.mt-3.mb-0 Are you sure you want to delete this appointment?
                small.text-muted This action cannot be undone.
        template(#modal-footer)
            .d-flex.justify-content-end.w-100(style="gap: 0.5rem;")
                b-button(variant="light" @click="closeModalDeleteAppointment") Cancel
                b-button(variant="danger" @click="deleteAppointment(staffEmail)")
                    Icon.mr-1(icon="mdi:trash-can-outline")
                    | Delete

    //---- Edit appointment modal ----//
    b-modal#modalEdit(title="Edit Appointment" modal-class="dsg-modal" v-model="showModalEdit" size="lg" scrollable no-close-on-backdrop)
        b-overlay(no-wrap)
            template(#overlay)
        template
            .dsg-form-section
                .dsg-form-section-title
                    Icon.mr-2(icon="mdi:account-outline")
                    | Client &amp; caregiver
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Client Name
                            span.dsg-req  *
                        b-form-input(v-model="selectedEditAppointment.clientName" type="text" placeholder="Enter client name")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Caregiver Name
                            span.dsg-req  *
                        b-form-input(v-model="selectedEditAppointment.caregiverName" type="text" placeholder="Enter caregiver name")
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Caregiver Email
                            span.dsg-req  *
                        b-form-input(v-model="selectedEditAppointment.email" type="email" placeholder="Enter caregiver email")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Phone Number
                        b-form-input(v-model="selectedEditAppointment.phoneNumber" type="tel" placeholder="Enter phone number")

            .dsg-form-section
                .dsg-form-section-title
                    Icon.mr-2(icon="mdi:calendar-clock")
                    | Schedule
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment Start Date
                            span.dsg-req  *
                        b-form-datepicker(:min="todayDate" v-model="selectedEditAppointment.appointmentStartDate")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment Start Time
                            span.dsg-req  *
                        p.dsg-inline-warn(v-if="notValidTime") Minimum 30 minutes from now.
                        b-time.w-100(locale="en" :min="minTime" v-model="selectedEditAppointment.appointmentStartTime")
                b-row
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment Hours
                        b-form-select(v-model="selectedEditAppointment.appointmentHour" :options="listOptionAppointmentHour")
                    b-col.col-12.col-md-6.mb-3
                        .dsg-field-label Appointment End Date and Time
                        b-form-input(type="text" :value="appointmentEndDateEditIsoString" disabled)

        template(#modal-footer)
            .d-flex.align-items-center.justify-content-between.w-100
                small.text-muted(v-if="disableSubmitEdit")
                    | Fill in all fields marked with
                    span.dsg-req  *
                span(v-else)
                .d-flex(style="gap: 0.5rem;")
                    b-button(variant="light" @click="$bvModal.hide('modalEdit')" :disabled="loadingSubmitEdit") Cancel
                    b-button.btn-dsg(@click="onSubmitEditAppointment" :disabled="disableSubmitEdit || loadingSubmitEdit")
                        b-spinner(v-if="loadingSubmitEdit" small)
                        span(v-else)
                            Icon.mr-1(icon="mdi:content-save-outline")
                            | Save Changes

    //---- Page content ----//
    .dsg-page-header
        div
            h1.dsg-page-title
                Icon(icon="guidance:calendar")
                | Appointments
            p.dsg-page-subtitle Manage assessment appointments and Teams invites
        b-button.btn-dsg(@click="$bvModal.show('new-appointment')")
            Icon.mr-1(icon="mdi:plus")
            | Add New Appointment

    b-button-group.dsg-segment.mb-3(size="sm")
        b-button(:variant="filter === 'all' ? 'primary' : 'outline-primary'" @click="filter = 'all'") All
        b-button(:variant="filter === 'upcoming' ? 'primary' : 'outline-primary'" @click="filter = 'upcoming'") Upcoming
        b-button(:variant="filter === 'past' ? 'primary' : 'outline-primary'" @click="filter = 'past'") Past

    .dsg-table-wrap
        b-table.dsg-table(
            :fields="tableFields"
            :items="filteredMappedList"
            responsive
            hover
            show-empty
        )
            template(#empty="scope")
                .dsg-empty(v-if="isFetchingAdminDashboardData")
                    b-spinner(variant="primary")
                .dsg-empty(v-else)
                    Icon.dsg-empty-icon(icon="guidance:calendar" width="48")
                    p.mb-0 No appointments to show
            template(#cell(clientName)="data")
                span.font-weight-600 {{ data.item.clientName }}
            template(#cell(caregiverName)="data")
                span {{ data.item.caregiverName }}
            template(#cell(email)="data")
                span.dsg-ellipsis {{ data.item.email }}
            template(#cell(appointmentStartDate)="data")
                span {{ data.item.dateOfAppointmentStartDate }}
            template(#cell(appointmentEndDate)="data")
                span {{ data.item.dateOfAppointmentEndDate }}
            template(#cell(Manage)="data")
                .d-flex(style="gap: 0.4rem;")
                    b-button.dsg-icon-btn(variant="outline-primary" size="sm" v-b-tooltip.hover title="Edit" @click="showEditModalFunc(data.item)")
                        b-icon(icon="pencil")
                    b-button.dsg-icon-btn(variant="outline-danger" size="sm" v-b-tooltip.hover title="Delete" @click="openModalDeleteAppointment(data.item.crb5c_fowappointmentid, data.item.crb5c_meetingteamsid)")
                        b-icon(icon="trash")

    p.dsg-count Total appointment: {{ filteredMappedList.length }}
</template>

<script>
import dayjs from 'dayjs';
import { mapState, mapMutations, mapActions } from 'vuex';
import { z } from 'zod';
import { Icon } from '@iconify/vue2';
import authModule from '../../store/authenticator.js';
import { ADMIN_DASHBOARD_NAMESPACE, MUTATIONS, ACTIONS } from "../../store/Modules/AdminDashboard/types-admin-dashboard.js";
// eslint-disable-next-line no-unused-vars
import { TABLE } from '../../store/ModuleName';
import axios from 'axios';


export default {
    components: {
        Icon,
    },
    data() {
        return {
            filter: 'upcoming',
            notValidTime: false,
            minTime: '00:00' ,
            todayDate: dayjs().format('YYYY-MM-DD'),
            staffEmail: null,
            staffName: null,
            listRegistrationLink: [
            "https://dsg-form.pages.dev/reg?type=fow",
            "https://dsg-form.pages.dev/reg?type=cip"
            ],
            showModalEdit: false,
            loadingSubmitEdit: false,   
            tableFields: [
                // "No",
                { 
                    key: "clientName", 
                    label: "Client Name",
                    sortable: true,
                },
                { 
                    key: "caregiverName", 
                    label: "Caregiver Name",
                },
                { 
                    key: "email", 
                    label: "Email",
                },
                // { 
                //     key: "phoneNo", 
                //     label: "Phone No",
                // },
                // {
                //     key: "clientType",
                //     label: "Client Type",
                // },
                { 
                    key: "appointmentStartDate", 
                    label: "Appointment Start Date",
                    // sortable: true,
                },
                { 
                    key: "appointmentEndDate", 
                    label: "Appointment End Date",
                },
                "Manage",
            ],
            inputNewAppointment: {
                clientName: null,
                caregiverName: null,
                email: null,
                phoneNumber: null,
                appointmentStartDate: null,
                appointmentStartTime: null,
                appointmentHour: 0.5,
                // appointmentEndDate: null,
                isEditingRegistrationLink: false,
                typeClient: "FOW",
            },
            listOptionTypeClient: [
                { value: "FOW", text: "FOW" },
                { value: "CIP", text: "CIP" }
            ],
            inputAppointmentEmail: {
                registrationLink: null,
                // caregiverEmail: null,
                // emailSubject: null,
                // emailMessage: null,
            },
            listOptionAppointmentHour: [
                { value: 0.5, text: "30 minutes" },
                { value: 1, text: "1 hour" },
                { value: 1.5, text: "1 hour 30 minutes" }
            ],
            clients: [],
            filteredClients:[],
            form: {
                name: '',
                caregivername: '',
                // typeAppointment: '',
                date: null,
                phone: '',
                email: '',
                message: ''
            },
            show: true,
            value: '',
            context: null,
            nameModal: {
                modalClientId: null,
                data: null
            },
            datefilter1:null,
            datefilter2:null,
            isSubmitAddNewAppointment: false,
            modalDeleteAppointment: {
                modalId: null,
                isDeleteAppointmentItem: false,
            },
            selectedEditAppointment: {
                clientName: null,
                caregiverName: null,
                email: null,
                phoneNumber: null,
                appointmentStartDate: null,
                appointmentStartTime: null,
                appointmentHour: 0.5,
                id: null,
                meetingTeamsId: null,
            },
            type: "FOW",
        }
    },
    async mounted(){
        this.staffEmail = this.username;
        this.staffName = this.displayname;
    },
    computed: {
        displayname() {
            return authModule.displayname;
        },
        username() {
            return authModule.username;
        },
        disableSubmitEdit(){
            if ((this.selectedEditAppointment.clientName &&  this.selectedEditAppointment.caregiverName &&  this.selectedEditAppointment.appointmentStartDate 
            &&  this.selectedEditAppointment.email &&  this.selectedEditAppointment.appointmentStartTime) && !this.notValidTime) {
            return false;     
            }
            return true;
        },
        disableSubmit(){
            if ((this.inputNewAppointment.clientName &&  this.inputNewAppointment.caregiverName &&  this.inputNewAppointment.appointmentStartDate 
            &&  this.inputNewAppointment.email &&  this.inputNewAppointment.appointmentStartTime) && !this.notValidTime) {
            return false;     
            }
            return true;
        },
        ...mapState({
            currentAdmin: state => state.currentAdmin,
            listUpcomingAppointment: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listUpcomingAppointment),
            // listClient: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.listClient),
            isFetchingAdminDashboardData: state => (state[ADMIN_DASHBOARD_NAMESPACE].adminDashboard.isFetchingAdminDashboardData),
        }),
        appointmentEndDateIsoString(){
            const { appointmentStartDate, appointmentStartTime, appointmentHour } = this.inputNewAppointment;
            if(!appointmentStartDate || !appointmentStartTime || !appointmentHour){
                return "No date";
            }

            let dateIsoString;

            if(appointmentHour === 0.5){
                dateIsoString = dayjs(`${appointmentStartDate} ${appointmentStartTime}`).add(30, "m").toISOString();
            }
            if(appointmentHour === 1){
                dateIsoString = dayjs(`${appointmentStartDate} ${appointmentStartTime}`).add(1, "h").toISOString();
            }
            if(appointmentHour === 1.5){
                dateIsoString = dayjs(`${appointmentStartDate} ${appointmentStartTime}`).add(1, "h").add(30, "m").toISOString();
            }

            return dayjs(dateIsoString).format('DD MMM YY, hh:mm A');

        },
        appointmentEndDateEditIsoString() {
            const { appointmentStartDate, appointmentStartTime, appointmentHour } = this.selectedEditAppointment;
            // console.log("appointmentEndDateEditIsoString: ", appointmentStartDate, appointmentStartTime, appointmentHour);

            if (!appointmentStartDate || !appointmentStartTime || !appointmentHour) {
                return "No date";
            }


            const dateOnly = appointmentStartDate.split("T")[0];


            const startDateTime = dayjs(`${dateOnly} ${appointmentStartTime}`, "YYYY-MM-DD HH:mm");

            if (!startDateTime.isValid()) {
                return "Invalid date";
            }

            let dateIsoString;

            if (appointmentHour === 0.5) {
                dateIsoString = startDateTime.add(30, "m").toISOString();
            } else if (appointmentHour === 1) {
                dateIsoString = startDateTime.add(1, "h").toISOString();
            } else if (appointmentHour === 1.5) {
                dateIsoString = startDateTime.add(1, "h").add(30, "m").toISOString();
            }

            return dayjs(dateIsoString).format("DD MMM YY, hh:mm A");
        },
        filteredMappedList(){
            if(this.filter === "all"){
                return this.mappedListUpcomingAppointment;
            }
            if(this.filter === "upcoming"){
                return this.mappedListUpcomingAppointment.filter(item => dayjs(item.dateOfAppointmentStartDate).isAfter(dayjs()));
            }
            if(this.filter === "past"){
                return this.mappedListUpcomingAppointment.filter(item => dayjs(item.dateOfAppointmentStartDate).isBefore(dayjs()));
            }
            return this.mappedListUpcomingAppointment;
        },
        mappedListUpcomingAppointment(){
            if(this.listUpcomingAppointment.length === 0){
                return [];
            }

            const appointments = [...this.listUpcomingAppointment];
            
            return appointments
            .sort((a, b) => dayjs(b.crb5c_appointmentdate).valueOf() - dayjs(a.crb5c_appointmentdate).valueOf())
            .map((item, index) => ({
                no: index + 1,
                clientName: item?.crb5c_clientname,
                caregiverName: item?.crb5c_caregivername,
                phoneNo: item?.crb5c_phonenumber,
                email: item?.crb5c_email,
                dateOfAppointmentStartDate : dayjs(item?.crb5c_appointmentdate).format("DD MMM YY  hh:mm A (dddd)"),
                dateOfAppointmentEndDate : dayjs(item?.crb5c_appointmentenddate).format("DD MMM YY hh:mm A (dddd)"),
                crb5c_fowappointmentid: item?.crb5c_fowappointmentid,
                crb5c_meetingteamsid: item?.crb5c_meetingteamsid,
            }))
        }
    },
    methods: {
        showEditModalFunc(data){
            console.log("data: ", data)
            this.showModalEdit = true;
            this.selectedEditAppointment.clientName = data.clientName;
            this.selectedEditAppointment.caregiverName = data.caregiverName;
            this.selectedEditAppointment.email = data.email;
            this.selectedEditAppointment.phoneNumber = data.phoneNo;
            this.selectedEditAppointment.appointmentStartDate = data.dateOfAppointmentStartDate;
            this.selectedEditAppointment.appointmentStartTime = dayjs(data.dateOfAppointmentStartDate).format("HH:mm");
            this.selectedEditAppointment.id = data.crb5c_fowappointmentid;
            this.selectedEditAppointment.meetingTeamsId = data.crb5c_meetingteamsid;

        },
        
        checkDateTimeValidity(date, time) {
        const selectedDateTime = dayjs(`${date} ${time}`);
        const currentDateTime = dayjs();
            if (selectedDateTime.isBefore(currentDateTime)) {
                this.notValidTime = true;
            }
            else{
                this.notValidTime = false;
            }
        },
        ...mapMutations(ADMIN_DASHBOARD_NAMESPACE, [
            MUTATIONS.REMOVE_ITEM_FROM_LIST_APPOINTMENT,
        ]),
        ...mapActions(ADMIN_DASHBOARD_NAMESPACE, [
           ACTIONS.DB_ADD_APPOINTMENT,
           ACTIONS.SEND_EMAIL_REMINDER_ASSESSMENT,
           ACTIONS.DB_GET_APPOINTMENT,
        ]),
        async getTeamsCalendar(staffEmail){
            // console.log('getTeamsCalendar',staffEmail)
            try {
                if(!staffEmail){
                    return;
                }
                
                const queryParams = new URLSearchParams({
                    staffEmail,
                });
                const { data } = await this.$store.getters[`${TABLE}/api`].get(`/admin_dashboard/meetingCalendar?${queryParams.toString()}`);
                console.log("Teams calendar data: ", data);
                
            } catch (error) {
                console.error(error);
            }

        },
        async postTeamsCalendar(staffEmail, eventTitle, startDate, endDate){
            // console.log('postTeamsCalendar',staffEmail)
            try {
                return await this.$store.getters[`${TABLE}/api`].post(`/admin_dashboard/meetingCalendar`, {
                    staffEmail,
                    eventTitle,
                    startDate, 
                    endDate
                });
                
            } catch (error) {
                console.error(error);
                alert("Fail to add appointment");
                return null;
            }

        },
        async deleteTeamsCalendar(staffEmail, teamsCalendarId){
            try {
                await this.$store.getters[`${TABLE}/api`].delete(`/admin_dashboard/meetingCalendar`, {
                    data: {
                        staffEmail, 
                        teamsCalendarId,
                    }
                });

            } catch (error) {
                console.error(error);
            }
        },
        formatDate(rawDate){
            if(!rawDate){
                return "No Date";
            }

            return dayjs(rawDate).format("DD MMM YY, hh:mm A");
        },
        filterDate(){
            if(this.datefilter1 !== null && this.datefilter2 !== null){
                /*for(let i = 0 ; i < this.clients.length; i++){
                    if((dayjs(this.clients[i].clientDate).isAfter(dayjs(this.datefilter1)) && dayjs(this.clients[i].clientDate).isBefore(this.datefilter2))){
                        filtered.push(this.clients[i])
                    } 
                }*/
                this.filteredClients = this.clients
                .filter(client => dayjs(client.clientDate).isAfter(dayjs(this.datefilter1)) && dayjs(client.clientDate).isBefore(this.datefilter2))
            }else{
                this.filteredClients = this.clients
                alert("Select both filter dates.")
            }
        },
        clearDate(){
            this.datefilter1 = null;
            this.datefilter2 = null;
            this.filteredClients = this.clients
        },
        clearInputAddNewAppointement(){
            this.inputNewAppointment.clientName = null;
            this.inputNewAppointment.caregiverName = null,
            this.inputNewAppointment.email = null,
            this.inputNewAppointment.phoneNumber = null,
            this.inputNewAppointment.appointmentStartDate = null;
            this.inputNewAppointment.appointmentStartTime = null;
            this.inputNewAppointment.typeClient = "FOW";
            // this.inputNewAppointment.appointmentEndDate = null;
            
        },
        // async sendEmailToCaregiver(staffEmail, caregiverEmail, clientName, startDateIsoString, typeClient){
        async sendEmailToCaregiver(staffEmail, caregiverEmail, clientName, startDateIsoString,staffName,update=false,typeClient="FOW"){
            try {
                const { registrationLink } = this.inputAppointmentEmail;
                const dateAppointmentFormatted = dayjs(startDateIsoString).format("DD-MMM-YYYY (dddd)");
                const timeAppointmentFormatted = dayjs(startDateIsoString).format("h.mm A");
                let appointmentType = typeClient === "CIP" ? "CIP" : "FOW";
                const emailSubject = `
                ${update ? `Rescheduled ${appointmentType} Appointment` : `${appointmentType} Appointment`} for ${clientName} on ${dateAppointmentFormatted} at ${timeAppointmentFormatted}`;
                // const listFowEmailMessage = [
                //     "Dear Caregiver,",
                //     `Please assist us to complete this registration form before you bring your loved ones Mr ${clientName} to our Centre for assessment on ${dateAppointmentFormatted} at ${timeAppointmentFormatted} : <a href="${registrationLink}" target="_blank">Registration Link</a>.`,
                //     `On the day of assessment on ${dateAppointmentFormatted}, we will collect a one-time assessment fee of $50 + GST and a one-month refundable deposit of $340. The preferred mode of payment is via scanned QR code for PayLah or PayNow. Alternatively, cash is also acceptable.`,
                //     `Our address is : 20 Bendemeer Rd #01-02, BS Bendemeer Centre, Singapore 339914 (Please press the bell at the glass door that is opposite a café).`,
                //     `Attached is an information write-up about our Family of Wisdom programme.`,
                //     `For any further queries, you may contact us either at 63895385 or 80205006.`,
                // ];

                // const listCipEmailMessage = [
                //     "Dear Caregiver,",
                //     `Please assist us to complete this registration form before you bring your loved ones Mr ${clientName} to our Centre for assessment on ${dateAppointmentFormatted} at ${timeAppointmentFormatted} : <a href="${registrationLink}" target="_blank">Registration Link</a>.`,
                //     `On the day of assessment on ${dateAppointmentFormatted}, we will collect a one-time registration fee of $50 + GST and an advance fee for the entire month. The one-time assessment fee also includes a one-session free trial. The preferred mode of payment is via scanned QR code for PayLah or PayNow. Alternatively, cash is also acceptable.`,
                //     `Our address is : 20 Bendemeer Rd #01-02, BS Bendemeer Centre, Singapore 339914 (Please press the bell at the glass door that is opposite a café).`,
                //     `Attached is an information write-up about our Family of Wisdom programme.`,
                //     `For any further queries, you may contact us either at 63895385 or 80205006.`,
                // ];


                let listEmailMessage
                if(!update){
                if (typeClient === "CIP") {
                    listEmailMessage = [
                        "Dear Caregiver,",
                        `Please assist us to complete this registration form before you bring your loved one, ${clientName} to our Centre for assessment on ${dateAppointmentFormatted} at ${timeAppointmentFormatted} : <a href="${registrationLink}" target="_blank">Registration Link</a>.`,
                        `On the day of assessment on ${dateAppointmentFormatted}, we will collect a one-time assessment fee of 54.50 (after GST) and upfront payment of 14 sessions, based on your loved ones subsidized rate. Any unused sessions will be refunded to you at the end of 14 sessions. The preferred payment method is via scanned QR code for PayLah or PayNow. Alternatively, cash is also acceptable.`,
                        `Our address is : 20 Bendemeer Rd #01-02, BS Bendemeer Centre, Singapore 339914 (Please press the bell at the glass door that is opposite a café). `,
                        `For any further queries, you may contact us either at (+65) 63895385 or (+65) 83334080.`
                       
                    ];
                } else {
                    listEmailMessage= [
                        "Dear Caregiver,",
                        `Please assist us to complete this registration form before you bring your loved one, ${clientName} to our Centre for assessment on ${dateAppointmentFormatted} at ${timeAppointmentFormatted} : <a href="${registrationLink}" target="_blank">Registration Link</a>.`,
                        `On the day of assessment on ${dateAppointmentFormatted}, we will collect a one-time assessment fee of 54.50 (after GST)  and a one-month refundable deposit of $340. The preferred payment method is via scanned QR code for PayLah or PayNow. Alternatively, cash is also acceptable.`,
                        `Our address is : 20 Bendemeer Rd #01-02, BS Bendemeer Centre, Singapore 339914 (Please press the bell at the glass door that is opposite a café).`,
                        `For any further queries, you may contact us either at (+65) 63895385 or (+65) 80205006.`
                       
                    ];
                }
                }
                if(update){
                    listEmailMessage = [
                        "Dear Caregiver,",
                        `Your appointment for ${clientName} has been rescheduled to ${dateAppointmentFormatted} at ${timeAppointmentFormatted}.`,
                        `Please assist us to complete this registration form before you bring your loved one, ${clientName} to our Centre for assessment on ${dateAppointmentFormatted} at ${timeAppointmentFormatted} : <a href="${registrationLink}" target="_blank">Registration Link</a>. If you have already completed the registration form, no further action is needed regarding the form.`,
                        `On the day of assessment on ${dateAppointmentFormatted}, we will collect a one-time assessment fee of 54.50 (after GST) and a one-month refundable deposit of $340. The preferred payment method is via scanned QR code for PayLah or PayNow. Alternatively, cash is also acceptable.`,
                        `Our address is : 20 Bendemeer Rd #01-02, BS Bendemeer Centre, Singapore 339914 (Please press the bell at the glass door that is opposite a café). For any further queries, you may contact us either at (+65) 63895385 or (+65) 80205006.`
                    ];
                }


                
                // const data = await this[ACTIONS.SEND_EMAIL_REMINDER_ASSESSMENT]({
                //     staffEmail,
                //     caregiverEmail,
                //     emailSubject,
                //     // emailMessage,
                //     listEmailMessage: typeClient === "FOW" ? listFowEmailMessage : listCipEmailMessage,
                //     typeClient,
                // });



                const data = await this[ACTIONS.SEND_EMAIL_REMINDER_ASSESSMENT]({
                    staffEmail,
                    caregiverEmail,
                    emailSubject,
                    // emailMessage,
                    listEmailMessage,
                    staffName,
                    typeClient,
                    
                });
        
                if(!data){
                    throw new Error("No data");
                }

            } catch (error) {
                console.error(error);
            }



        },
        validateAppointmentForm(payloadInputAppointment){
            try {
                // const phoneRegex = new RegExp(/^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/);

                const SchemaAppointmentForm = z.object({
                    clientName: z.string(),
                    caregiverName: z.string(),
                    email: z.string().email(),
                    // phoneNumber: z.string().regex(phoneRegex, 'Invalid Number!'),
                    appointmentStartDate: z.string().datetime(),
                    appointmentEndDate: z.string().datetime(),
                    registrationLink: z.string().url(),
                })
                .strict();

                SchemaAppointmentForm.parse(payloadInputAppointment);
                
                return true;

            } catch (error) {
                console.error(error);
                alert("Please complete appointment form with correct format");
                
                return false;
            }
        },
        async onSubmit() {
            try {
                const { 
                    clientName,
                    caregiverName,
                    email,
                    // phoneNumber, 
                    appointmentStartDate,
                    appointmentStartTime,
                    typeClient
                } = this.inputNewAppointment;

                if(typeClient === "FOW"){
                    this.inputAppointmentEmail.registrationLink = this.listRegistrationLink[0];
                }

                if(typeClient === "CIP"){
                    this.inputAppointmentEmail.registrationLink = this.listRegistrationLink[1];
                }

                // this.inputAppointmentEmail.registrationLink = this.listRegistrationLink[0];

                let { registrationLink } = this.inputAppointmentEmail;
                
                const appointmentStartDateISOstring = dayjs(`${appointmentStartDate} ${appointmentStartTime}`).toISOString();
                const appointmentEndDateISOstring = dayjs(this.appointmentEndDateIsoString).toISOString();

                const payloadForValidation = {
                    clientName,
                    caregiverName,
                    email,
                    // phoneNumber, 
                    appointmentStartDate: appointmentStartDateISOstring,
                    appointmentEndDate: appointmentEndDateISOstring,
                    registrationLink,
                }

                const isValid = this.validateAppointmentForm(payloadForValidation);
                
                if(!isValid){
                    return;
                }


                this.isSubmitAddNewAppointment = true;

                const appointmentName = `Appointment ${clientName} ${typeClient}`;
                const { data: teamsData } = await this.postTeamsCalendar(
                    this.staffEmail, 
                    appointmentName, 
                    appointmentStartDateISOstring,
                    appointmentEndDateISOstring,
                );

                if(!teamsData){
                    this.isSubmitAddNewAppointment = false;
                    return;
                }

                // Store all event IDs (format: email1:id1,email2:id2)
                // This handles cases where meetings are created for multiple admin emails
                const meetingTeamsId = teamsData.id || '';

                // do post request to post appointment table
                const data = await this[ACTIONS.DB_ADD_APPOINTMENT]({
                    clientName,
                    caregiverName,
                    email,
                    // phoneNumber, 
                    appointmentStartDate: appointmentStartDateISOstring,
                    appointmentEndDate: appointmentEndDateISOstring,
                    meetingTeamsId: meetingTeamsId,
                });

                if(!data){
                    throw new Error("Response is empty");
                }
                
                await this.sendEmailToCaregiver(this.staffEmail, email, clientName, appointmentStartDateISOstring,this.staffName, false, typeClient);

                console.log("response after submit: ", data);

                alert("Add appointment successful!");

                await this[ACTIONS.DB_GET_APPOINTMENT]();
                
                this.$nextTick(() =>{
                    this.$bvModal.hide('new-appointment');
                });

                this.clearInputAddNewAppointement();
                this.isSubmitAddNewAppointment = false;
                // location.reload();
                
            } catch (error) {
                console.error(error);
                this.isSubmitAddNewAppointment = false;
                this.clearInputAddNewAppointement();
                alert("Fail to add appointment!");
                this.$nextTick(() =>{
                    this.$bvModal.hide('new-appointment')
                });
            }
            
        },
        async onSubmitEditAppointment() {
    try {
        const {
            clientName,
            caregiverName,
            email,
            phoneNumber,
            appointmentStartDate,
            appointmentStartTime,
            appointmentHour,
            meetingTeamsId,
        } = this.selectedEditAppointment;

        const dateOnly = appointmentStartDate.split("T")[0];
        const startDateTime = dayjs(`${dateOnly} ${appointmentStartTime}`, "YYYY-MM-DD HH:mm");

        if (!startDateTime.isValid()) {
            alert("Invalid appointment start time.");
            return;
        }

        let endDateTime;

        if (appointmentHour === 0.5) {
            endDateTime = startDateTime.add(30, "m");
        } else if (appointmentHour === 1) {
            endDateTime = startDateTime.add(1, "h");
        } else if (appointmentHour === 1.5) {
            endDateTime = startDateTime.add(1, "h").add(30, "m");
        } else {
            alert("Invalid appointment hour.");
            return;
        }

        this.inputAppointmentEmail.registrationLink = this.listRegistrationLink[0];
        const { registrationLink } = this.inputAppointmentEmail;

        const appointmentStartDateISOstring = startDateTime.toISOString();
        const appointmentEndDateISOstring = endDateTime.toISOString();
        // let regLink = this.listRegistrationLink[0];
        // console.log("regLink: ", regLink);

        const payload = {
            clientName,
            caregiverName,
            email,
            // phoneNumber,
            appointmentStartDate: appointmentStartDateISOstring,
            appointmentEndDate: appointmentEndDateISOstring,
            registrationLink,
        };

        const isValid = this.validateAppointmentForm(payload);
        if (!isValid) return;
        this.loadingSubmitEdit = true;

        this.isSubmitEditAppointment = true;

        // Delete old Teams meeting(s) - handles both single and multiple IDs
        if (meetingTeamsId) {
            // console.log("Deleting old Teams meeting with ID:", meetingTeamsId, this.staffEmail);
            await this.deleteTeamsCalendar(
                this.staffEmail,
                meetingTeamsId
            );
        }

        // Create new Teams meeting(s)
        const appointmentName = `Appointment ${clientName}`;
        const { data: newTeamsData } = await this.postTeamsCalendar(
            this.staffEmail,
            appointmentName,
            appointmentStartDateISOstring,
            appointmentEndDateISOstring
        );

        if (!newTeamsData || !newTeamsData.id) {
            throw new Error("Failed to create new Teams meeting.");
        }
        payload.phoneNumber = phoneNumber;
        // Store all event IDs (format: email1:id1,email2:id2)
        payload.meetingTeamsId = newTeamsData.id;
        

        const { data: updated } = await axios.put(
            "/api/admin_dashboard/addAssessmentAppointment",
            {
                ...payload,
                id: this.selectedEditAppointment.id,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
            
        );

        if (!updated) {
            throw new Error("Failed to update appointment.");
        }

        
        await this.sendEmailToCaregiver(
            this.staffEmail,
            email,
            clientName,
            appointmentStartDateISOstring,
            this.staffName,
            true 
        );

        

        await this[ACTIONS.DB_GET_APPOINTMENT]();

        this.$nextTick(() => {
            this.$bvModal.hide("modalEdit");
        });

        this.clearInputEditAppointment();
        this.isSubmitEditAppointment = false;
        alert("Appointment updated successfully!");

    } catch (error) {
        console.log(error);
        this.isSubmitEditAppointment = false;
        alert("Failed to update appointment.");
        
    }finally {
        this.loadingSubmitEdit = false;
    }
},
        clearInputEditAppointment(){
            this.selectedEditAppointment.clientName = null;
            this.selectedEditAppointment.caregiverName = null,
            this.selectedEditAppointment.email = null,
            this.selectedEditAppointment.phoneNumber = null,
            this.selectedEditAppointment.appointmentStartDate = null;
            this.selectedEditAppointment.appointmentStartTime = null;
            this.selectedEditAppointment.appointmentHour = 0.5;
        },
        openModalDeleteAppointment(crb5c_fowappointmentid, crb5c_meetingteamsid){
            const modalId = `modalDelete/${crb5c_fowappointmentid}/${crb5c_meetingteamsid}`;
            this.modalDeleteAppointment.modalId = modalId;
            this.$nextTick(() => {
                this.$bvModal.show(this.modalDeleteAppointment.modalId);
            });

        },
        closeModalDeleteAppointment(){
            this.$bvModal.hide(this.modalDeleteAppointment.modalId);
            this.modalDeleteAppointment.modalId = null;

        },
        async deleteAppointment(staffEmail){
            try {
                if(!this.modalDeleteAppointment.modalId){
                    return;
                }

                this.modalDeleteAppointment.isDeleteAppointmentItem = true;
    
                // eslint-disable-next-line no-unused-vars
                const [_, crb5c_fowappointmentid, teamsCalendarId] = this.modalDeleteAppointment.modalId.split("/");
                await this.dbDeleteAppointment(crb5c_fowappointmentid);
                await this.deleteTeamsCalendar(staffEmail, teamsCalendarId);

                this.modalDeleteAppointment.isDeleteAppointmentItem = false;
                this.closeModalDeleteAppointment();
                alert("Delete appoinment sucessful");
                
            } catch (error) {
                console.error(error);
                this.closeModalDeleteAppointment();
                alert("Delete appoinment failed");
            }


        },
        async dbDeleteAppointment(crb5c_fowappointmentid){
            await this.$store.getters[[`${TABLE}/api`]].delete("/admin_dashboard/addAssessmentAppointment", {
                data: {
                    crb5c_fowappointmentid,
                }
            });
            this[MUTATIONS.REMOVE_ITEM_FROM_LIST_APPOINTMENT](crb5c_fowappointmentid);

        },
        backAdminHomepage() {
            this.$router.push({ path: '/adminhomepage' })
        },
        moveToHomePage(){
            this.$router.push({ path: "/" })
        },
        openNameModal(clientId){
            this.nameModal.modalClientId = `sendModal-${clientId}`
            this.nameModal.data = this.listModalData(this.nameModal.modalClientId)
            this.$nextTick(() =>{
                this.$bvModal.show(this.nameModal.modalClientId)
            })

            console.log("data: ", this.nameModal.data)
        },
        listModalData(modalClientId){
            const clientId = modalClientId.split("-")[1]

            return this.clients
            .filter(client => client.id === +clientId)
        },
        hideNameModal(){
            this.$bvModal.hide(this.nameModal.modalClientId)

            this.nameModal.modalClientId = null
            this.nameModal.data = null
        }
    },
    watch: {
        'inputNewAppointment.appointmentStartDate'(newDate) {
            this.checkDateTimeValidity(newDate, this.inputNewAppointment.appointmentStartTime);
        },
        'inputNewAppointment.appointmentStartTime'(newTime) {
            this.checkDateTimeValidity(this.inputNewAppointment.appointmentStartDate, newTime);
        },
        // async currentAdmin(value){
        //     if(value.username){
        //         console.log('currentadmin',value)
        //         this.staffName = value.name;
        //         this.staffEmail = value.username;
        //         await this.getTeamsCalendar(this.staffEmail);
        //         // this.deleteTeamsCalendar(value.username, "");

        //     }
        // }

    }
  
}
</script>

<style scoped>
.collapsed > .when-closed,
.not-collapsed > .when-open {
  display: none;
}

/* modal form sections */
.dsg-form-section {
  margin-bottom: 1.25rem;
}
.dsg-form-section:last-child {
  margin-bottom: 0;
}
.dsg-form-section-title {
  display: flex;
  align-items: center;
  font-weight: 700;
  color: var(--dsg-primary);
  font-size: 0.95rem;
  padding-bottom: 0.5rem;
  margin-bottom: 0.85rem;
  border-bottom: 1px solid var(--dsg-border);
}
.dsg-inline-warn {
  color: #dc3545;
  font-size: 0.8rem;
  margin: 0 0 0.35rem;
}
.font-weight-600 {
  font-weight: 600;
}
.dsg-ellipsis {
  max-width: 190px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>

